export default {
  hero: {
    title: "Who am I?",
    greeting:
      "Hi, I'm Faranack — a frontend developer and machine-learning researcher.",
    intro:
      "I design and build interfaces for web and mobile products, and I research machine learning for renewable energy at a Renewable Energy Systems & Nanofluid Applications in Heat Transfer lab — published work applying machine learning to optimize solar and thermoelectric energy systems. I like living at the intersection of shipped products and peer-reviewed research.",
  },
  connect: {
    title: "Connect With Me",
    subtitle:
      "Let's collaborate on something amazing! Reach out through any of these platforms.",
  },
  socialAriaLabel: "Faranack's {{label}}",
  socialLabels: {
    email: "Email",
    googleScholar: "Google Scholar",
    website: "Website",
    linkedin: "LinkedIn",
    github: "GitHub",
    instagram: "Instagram",
  },
};
